import { FC, useCallback, } from "react";
import { Box, } from "@chakra-ui/react";
import { IDetectedBarcode, Scanner, } from "@yudiel/react-qr-scanner";

import { PageLoader, } from "../../components/shared/PageLoader";
import { useCameraPermission, } from "../../components/features/hooks";
import { CameraDeniedView, CameraMaskView, QrPageHeader, } from "../../components/features/QrPage";

const SCANNER_CONSTRAINTS = {
  facingMode: "environment",
  height: { ideal: 720, },
  width: { ideal: 1280, },
} as const;

const SCANNER_COMPONENTS = { finder: false, } as const;

interface Props {
  onSuccess: (code: string) => void;
  onError: (error: unknown) => void;
}

export const QrViewDefault: FC<Props> = ({ onSuccess, onError, },) => {
  const { isGranted, status, } = useCameraPermission();

  const handleScan = useCallback((detectedCodes: IDetectedBarcode[],) => {
    if (detectedCodes.length === 0) {
      onSuccess("",);
    }

    const firstCode = detectedCodes[0];
    onSuccess(firstCode.rawValue,);
  }, [],);

  if (status === "denied") {
    return <CameraDeniedView />;
  }

  if (!isGranted) {
    return <PageLoader />;
  }

  return (
    <Box h="100vh" mx="-1rem" position="relative">
      <Scanner
        sound={false}
        components={SCANNER_COMPONENTS}
        constraints={SCANNER_CONSTRAINTS}
        onScan={handleScan}
        onError={onError}
      />

      <QrPageHeader />
      <CameraMaskView />
    </Box>
  );
};
